<section class="content">
  <mat-form-field>
    <mat-label>Select uploaded file</mat-label>
    <input type="text" placeholder="Search Uploaded file name" matInput [formControl]="uploadedFileControl"
      [matAutocomplete]="auto" (focus)="onFocus()" (blur)="updateUploadedFile($event.target.value)"
      (input)="uploadedFileChanges.next($event.target.value)" />
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="setUploadedFileChangeAction($event)">
      @for (option of uploadedFileSuggestions | async; track option) {
        <mat-option [value]="option">
          {{ option }}
        </mat-option>
      }
    </mat-autocomplete>
    @if (uploadedFileControl.hasError('noOption')) {
      <mat-error>
        Uploaded file not Found
      </mat-error>
    }
    @if (uploadedFileControl.hasError('required')) {
      <mat-error>
        Uploaded file is required
      </mat-error>
    }
  </mat-form-field>
</section>